import React from "react";
import { useActor } from "@xstate/react";
import TypeAhead from "../Typeahead";
import { GYM_SOFTWARE_COMPETITORS } from "../../../../constants/gymSoftwareCompetitors";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { BalancedStepTitle } from "../BalancedStepTitle";

const CurrentSoftwareStep: React.FC = () => {
  const machine = useSignUpMachine();
  // eslint-disable-next-line
  const [_, send] = useActor(machine);

  const handleChange = (value: any) => {
    send({
      type: "UPDATE_FORM",
      data: { [SignUpFormField.CurrentSoftware]: value?.value || value },
    });
  };

  const handleSubmit = () => {
    send({ type: "NEXT" });
  };

  const field = {
    id: SignUpFormField.CurrentSoftware,
    required: false,
    minimumInputLength: 2,
    placeholder: "Enter your current software",
    quickSelectOption: {
      label: "I'm not using another gym management software",
      value: "None",
      id: "input-current-software-default-none",
    },
    searchPrefixOnly: true,
    options: GYM_SOFTWARE_COMPETITORS.map((competitor) => ({
      id: `input-current-software-${competitor}`,
      label: competitor,
      value: competitor,
    })),
  };

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <BalancedStepTitle title="What's your current gym management software?" />
      </div>
      <div className="tw-space-y-4">
        <TypeAhead
          inputId={field.id}
          onChange={handleChange}
          minimumInputLength={field.minimumInputLength}
          options={field.options}
          placeHolder={field.placeholder}
          searchPrefixOnly={field.searchPrefixOnly}
          quickSelectOption={field.quickSelectOption}
          progressOnSelect={handleSubmit}
        />
      </div>
    </>
  );
};

export default CurrentSoftwareStep;
